import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    const iv = setInterval(async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        setStatus(r.data.payment_status);
        if (r.data.payment_status === "paid") clearInterval(iv);
      } catch (err) { console.error("Payment status poll failed:", err); }
      setTries((t) => t + 1);
    }, 2000);
    return () => clearInterval(iv);
  }, [sid]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#F7F6F2]">
      <div className="paper-card p-10 text-center max-w-md">
        <CheckCircle size={48} color="#1E3A2F" weight="fill" className="mx-auto mb-4" />
        <h1 className="text-3xl mb-2">{status === "paid" ? "You're all set!" : "Confirming payment…"}</h1>
        <p className="text-[#5C6B61] mb-6">{status === "paid" ? "Your BuzzerAI Pro subscription is active." : `Waiting for Stripe (${tries}s)`}</p>
        <Link to="/dashboard" className="btn-primary" data-testid="back-dash">Back to dashboard</Link>
      </div>
    </div>
  );
}
